import { MspInProductTrialsOverlayWindowsAppBaseDataProvider } from './MspInProductTrialsOverlayWindowsAppBaseDataProvider';
import { MspInProductTrialsAdditionalUserSettings } from '../view/configs/msp-in-product-trials-overlay-window-config';

export class MspInProductTrialsOverlayWindowsAppGzDataProvider extends MspInProductTrialsOverlayWindowsAppBaseDataProvider {
  public async getAdditionalUserSettingsForMspInProductTrials(): Promise<MspInProductTrialsAdditionalUserSettings> {
    const record =
      await this.dependencies.api.clients.AdditionalUserSettings.GetAdditionalUserSettingsForMspInProductTrials().toPromise();

    if (!record) {
      throw new Error('No data for additional user settings.');
    }

    return record;
  }
}
